import { RuleRender } from 'antd/lib/form';

export const validateFlowrate: RuleRender = ({ getFieldValue }) => ({
  validator: async () => {
    if (!getFieldValue(['detail', 'flowrate', 'value'])) {
      throw new Error('');
    }
    return await Promise.resolve();
  },
  validateTrigger: 'onSubmit',
});
